import React from "react";

export const JournalContext = React.createContext();